/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{create as r}from"../../../../core/libs/gl-matrix-2/factories/vec3f64.js";import{VertexNormalDrawParameters as i}from"../core/shaderLibrary/attributes/VertexNormal.glsl.js";class s extends i{constructor(i=r()){super(),this.origin=i,this.slicePlaneLocalOrigin=this.origin}}export{s as DrawParameters};
